import {
  LocationDashboardSchema,
  OrganisationOverviewSchema,
  type LocationDashboard,
} from "@safeplate/contracts";

import { requestApi } from "../api/client.js";

export type LocationDashboardMetrics = LocationDashboard;

export async function getLocationDashboard(
  locationId: string,
): Promise<LocationDashboardMetrics> {
  return LocationDashboardSchema.parse(
    await requestApi(`/locations/${locationId}/today`),
  );
}

export async function getOrganisationOverview() {
  return OrganisationOverviewSchema.parse(
    await requestApi("/orgs/current/overview"),
  );
}

export function metricDefinition(metric: string): string {
  const definitions: Record<string, string> = {
    attention:
      "Open follow-ups at this location, split by their recorded severity.",
    comingUp:
      "Active renewal reminders and the latest verification deadlines due in the next 60 local calendar days.",
    due: "Task occurrences in due status for this location's current local date; mandatory plan tasks are shown separately.",
    evidence:
      "Expected mandatory record slots filled over the last 30 local dates, calculated by the same missing-evidence engine as the PDF report; this is coverage, not a legal compliance score.",
    excluded:
      "Distinct staff in active sickness records who remain excluded from food handling and have no return date.",
    overdue:
      "Task occurrences in missed status before this location's current local date; mandatory plan tasks are shown separately.",
    range:
      "Active records with a warning or failed rule result over the last 30 local dates.",
    sync: "Devices reporting queued logs and activity within 24 hours, with no batch received for over 24 hours; completely offline devices cannot report their queue.",
    training:
      "Active staff for whom every assigned module at this location or organisation-wide is signed off and unexpired.",
  };
  return definitions[metric] ?? "A factual SafePlate dashboard count.";
}
